// @flow
import _ from 'lodash';
// Helpers
import { toSimpleLineItem } from './toSimpleLineItem';
// Types
import type { LineItem, SimpleLineItem } from '../types';

// Returns the line items that were added or had their quantity changed between two snapshots of the cart
export const computeCartChanges = (
  oldLineItems: LineItem[],
  newLineItems: LineItem[],
): SimpleLineItem[] => {
  if (newLineItems.length > oldLineItems.length) {
    const additionalLineItems = _.differenceBy(
      newLineItems,
      oldLineItems,
      'variantId',
    );

    return additionalLineItems.map(toSimpleLineItem);
  }

  // TODO: An item added while another is removed keeps the same length and is not detected
  if (newLineItems.length === oldLineItems.length) {
    const changedLineItems = [];
    for (let key of newLineItems.keys()) {
      const currentLineItem = newLineItems[key];
      if (!currentLineItem) {
        continue;
      }
      const comparableLineItem = _.find(oldLineItems, {
        variantId: currentLineItem.variantId,
      });
      if (
        currentLineItem &&
        comparableLineItem &&
        currentLineItem.quantity !== comparableLineItem.quantity
      ) {
        changedLineItems.push(currentLineItem);
      }
    }

    return changedLineItems.map(toSimpleLineItem);
  }

  return [];
};
